import styled, { css } from "styled-components";

export const FlexContainer = styled.div<IFlexContainerProps>`
    display: flex;
    flex-wrap: ${props => props.noWrap ? "nowrap" : "wrap"};
    ${props => props.asRow && css`
        flex-direction: row;
    `}
    ${props => props.asColumn && css`
        flex-direction: column;
    `}
    ${props => props.center && css`
        align-content: center;
    `}
    ${props => props.stretch && css`
        align-items: stretch;
    `}
    ${props => props.justifySpaceBetween && css`
        justify-content: space-between;
    `}
    ${props => props.justifySpaceAround && css`
        justify-content: space-around;
    `}
    ${props => props.justifyCenter && css`
        justify-content: center;
    `}
    ${props => props.justifyEnd && css`
        justify-content: flex-end;
    `}
    ${props => props.centerItems && css`
        align-items: center;
    `}
    ${props => props.alignItemsEnd && css`
        align-items: flex-end;
    `}
    ${props => props.isFullWidth && css`
        width: 100%;
    `}
    ${props => props.gap && css`
        gap: ${props.gap}px;
    `}
    ${props => props.whiteSpace && css`
        white-space: ${props.whiteSpace};
    `}

`

const handleFlex = (props: IFlexItemProps) => {
    if (props.fullWidth) {
        return "1 1 100%";
    } else if (props.flex) {
        return props.flex;
    } else {
        return "1";
    }
}

export const FlexItem = styled.div<IFlexItemProps>`
    flex: ${props => handleFlex(props)};
`

interface IFlexItemProps {
    fullWidth?: boolean;
    flex?: string;
}

interface IFlexContainerProps {
    asRow?: boolean;
    asColumn?: boolean;
    center?: boolean;
    centerItems?: boolean;
    alignItemsEnd?: boolean;
    stretch?: boolean;
    noWrap?: boolean;
    justifySpaceBetween?: boolean;
    justifySpaceAround?: boolean;
    justifyCenter?: boolean;
    justifyEnd?: boolean;
    isFullWidth?: boolean;
    gap?: number;
    whiteSpace?: string;
}
